import { Injectable } from "@angular/core";
import { IVisolFilePickerService, VisolExportConfig, VisolImportConfig } from "./visol-file-picker.service";

@Injectable()
export class BrowserVisolFilePickerService implements IVisolFilePickerService {
  importFiles({ extensions = [], multiple = false }: VisolImportConfig): Promise<File[]> {
    return new Promise((resolve) => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = extensions.join(",");
      input.multiple = multiple;
      // adding the input element in the dom makes integration testing through the ui continue to work
      input.onchange = () => {
        resolve(Array.from(input.files ?? []));
        document.body.removeChild(input);
      };
      document.body.appendChild(input);
      input.click();
    });
  }

  exportFile({ content, filename = "download" }: VisolExportConfig): Promise<void> {
    return new Promise((resolve) => {
      const url = URL.createObjectURL(content);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
      resolve();
    });
  }

  async exportFileWithResult(config: VisolExportConfig): Promise<boolean> {
    await this.exportFile(config);
    return true;
  }
}
